import FeatherIcon from "feather-icons-react"
import { useEffect, useRef, useState } from "react"
import { Divider, Dropdown, Header, Menu, Pagination } from "semantic-ui-react"
import { GenerateExcelByContactDocuments, GetAllDocumentsByContact } from "src/graphql/documents"
import { formatMoneyWithCurrency } from "src/utils/formatter"
import LoadingSpinner from "../../../../../general/js/spinnerLoading/index";
import { Obligaciones } from "src/utils/obligations"
import { ModalDocumentDetail } from "src/components/documentostributarios/modalDetalleDocumento/ModalDocumentDetail"


export const ContactDocument = ({ agendaId }) => {
    // ************************ variables ************************
    const [contactDocuments, setContactDocuments] = useState([]);
    const [totalToPay, setTotalToPay] = useState(0);
    const [totalOverdue, setTotalOverdue] = useState(0);
    const [totalDocuments, setTotalDocuments] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const tableRef = useRef(null);
    const [offset, setOffset] = useState(20);
    const [limit, setLimit] = useState(20);
    const [documentType, setDocumentType] = useState('TAX_DOCUMENT');
    const [obligationType, setObligationType] = useState('');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [modalData, setModalData] = useState();
    const options = [
        { key: 1, text: "20", value: 20 },
        { key: 2, text: "50", value: 50 },
        { key: 3, text: "100", value: 100 },
        { key: 4, text: "200", value: 200 },
    ];
    const totalPages = Math.max(1, Math.ceil(totalDocuments / (limit || 1)));
    const startResult = totalDocuments > 0 ? ((currentPage - 1) * limit) + 1 : 0;
    const endResult = Math.min(currentPage * limit, totalDocuments);

    const today = new Date();

    const optionsDropdown = [
        { key: 'TAX_DOCUMENT', text: 'Documentos', value: 'TAX_DOCUMENT' },
        { key: 'CREDIT', text: 'Créditos', value: 'CREDIT' },
        { key: 'OBLIGATION', text: 'Obligaciones', value: 'OBLIGATION' },
    ];

    const obligationsOptions = [
        {
            id: 'Lista de obligaciones',
            type: 'Lista de obligaciones',
            text: 'Lista de obligaciones',
            disabled: true,
            content: (
                <Header
                    style={{ fontSize: "1em" }}
                    content={'Lista de obligaciones'}
                    size="small"
                />
            ),
        },
        ...Obligaciones.reduce((acc, el) => {
            if (!acc) acc = [];
            const header = [
                {
                    id: el.type,
                    type: el.type,
                    text: el.typeLabel,
                    disabled: true,
                    content: (
                        <Header
                            style={{ fontSize: "1em" }}
                            content={el.typeLabel}
                            size="small"
                        />
                    ),
                },
            ];

            const children = el.subAreas.map((f) => ({
                id: f.type,
                name: f.type,
                text: f.typeLabel,
                value: f.type,
                disabled: false,
                content: f.typeLabel,
            }));
            const mix = [...header, ...children];

            return [...acc, ...mix];
        }, []),
    ];

    // ************************ graph ************************
    const { data: documentsByContact, fetching: fetchingDocumentsByContact } = GetAllDocumentsByContact({
        contactId: agendaId,
        pagination: {
            limit: limit,
            page: currentPage
        },
        documentType: documentType,
        obligationType: obligationType,
    });

    const { data: excelByContactDocumentsData, executeMutation: excelByContactDocuments } = GenerateExcelByContactDocuments()

    // ************************ logica ************************
    const getExcel = async () => {
        const { data: getExcelRes } = await excelByContactDocuments({ contactId: agendaId });

        if (getExcelRes?.generateExcelByContactDocuments) {
            window.open(getExcelRes?.generateExcelByContactDocuments);
        }
    }

    const onPageChange = (e, { activePage }) => {
        setCurrentPage(activePage);
        if (tableRef.current) {
            tableRef.current.scrollTo(0, 0);
        }
    };

    const onOffsetChange = (e, { value }) => {
        setCurrentPage(1);
        setLimit(value);
        setOffset(value);
    };

    const onValueChange = (e, { value }) => {
        const isDocumentType = ['TAX_DOCUMENT', 'CREDIT', 'OBLIGATION'].includes(value);

        if (isDocumentType) {
            setDocumentType(value);
            setObligationType('');
        } else {
            setDocumentType('');
            setObligationType(value);
        }
    }

    useEffect(() => {
        if (!documentsByContact?.getAllDocumentsByContact) return;

        setContactDocuments(documentsByContact?.getAllDocumentsByContact?.documents || []);
        setTotalToPay(documentsByContact?.getAllDocumentsByContact?.totalToPay || 0);
        setTotalOverdue(documentsByContact?.getAllDocumentsByContact?.totalOverdue || 0);
        setTotalDocuments(documentsByContact?.getAllDocumentsByContact?.totalDocuments || 0);
    }, [documentsByContact])

    useEffect(() => {
        if (!modalData) return;

        setShowDetailModal(true);
    }, [modalData]);

    return (
        <>
            <div className=" tw-h-[calc(100vh-15rem)] tw-flex tw-flex-col tw-gap-6 tw-mb-5 tw-flex-grow">
                <span className="tw-text-lg tw-font-medium tw-text-gray-800">
                    Documentos
                </span>

                <section className="tw-w-full tw-h-[63px] tw-flex tw-gap-4">
                    <div className="tw-flex-grow tw-rounded tw-bg-[#EEF8FF] tw-px-4 tw-py-3 tw-flex tw-items-center tw-gap-4">
                        <FeatherIcon
                            icon="dollar-sign"
                            size={21}
                            className="tw-text-[#1D7EE3]"
                        />

                        <div className="tw-flex tw-flex-col">
                            <span className="tw-text-sm tw-font-light tw-text-[#1D7EE3]">
                                Total adeudado
                            </span>
                            <span className="tw-text-lg tw-font-normal tw-text-[#1D7EE3]">
                                {formatMoneyWithCurrency(totalToPay)}
                            </span>
                        </div>
                    </div>

                    <div className="tw-flex-grow tw-rounded tw-bg-red-50 tw-px-4 tw-py-3 tw-flex tw-items-center tw-gap-4">
                        <FeatherIcon
                            icon="alert-triangle"
                            size={21}
                            className="tw-text-red-600"
                        />

                        <div className="tw-flex tw-flex-col">
                            <span className="tw-text-sm tw-font-light tw-text-red-600">
                                Total atrasado
                            </span>
                            <span className="tw-text-lg tw-font-normal tw-text-red-600">
                                {formatMoneyWithCurrency(totalOverdue)}
                            </span>
                        </div>
                    </div>
                </section>
                <Divider className="!tw-m-0" />

                <section className="tw-flex tw-justify-between">
                    <Dropdown
                        placeholder='Seleccionar tipo de documento'
                        clearable
                        fluid
                        search
                        selection
                        defaultValue={'TAX_DOCUMENT'}
                        onChange={onValueChange}
                        style={{ width: "400px" }}
                        options={[...optionsDropdown, ...obligationsOptions]}
                        className="!tw-w-[260px]"
                    />
                    {
                        contactDocuments.length > 0 &&
                        <button
                            className="tw-w-[106px] tw-h-[35px] tw-bg-transparent tw-border-solid tw-border-[#0099FF] tw-justify-self-end tw-text-[#0099FF] tw-px-6 tw-flex tw-items-center tw-rounded tw-gap-2"
                            onClick={(event) => {
                                event.preventDefault();
                                getExcel();
                            }}
                        >
                            <FeatherIcon icon="download" size={16} />
                            <span className="tw-text-base tw-font-medium">
                                Excel
                            </span>
                        </button>
                    }
                </section>

                {
                    contactDocuments.length > 0 ?
                        <div className="tw-h-[calc(76vh-15rem)] tw-ring-green-400 tw-flex tw-flex-col tw-gap-2">
                            <section className="tw-w-[99%] tw-h-[39px] tw-rounded-xl tw-bg-[#EEF8FF] tw-flex tw-items-center tw-text-gray-700">
                                <div className="tw-w-[13.8%] tw-px-4 tw-py-3">
                                    <span className="tw-text-sm tw-font-medium">
                                        Folio
                                    </span>
                                </div>
                                <div className="tw-w-[37.3%] tw-px-4 tw-py-3">
                                    <span className="tw-text-sm tw-font-medium">
                                        Tipo de documento
                                    </span>
                                </div>
                                <div className="tw-w-[20.7%] tw-px-4 tw-py-3">
                                    <span className="tw-text-sm tw-font-medium">
                                        Estado de pago
                                    </span>
                                </div>
                                <div className="tw-w-[21.5%] tw-px-4 tw-py-3 tw-text-right">
                                    <span className="tw-text-sm tw-font-medium">
                                        Monto bruto
                                    </span>
                                </div>
                            </section>
                            <div
                                className="tw-h-full tw-overflow-y-auto tw-flex tw-flex-col tw-gap-2"
                                ref={tableRef}
                            >
                                {contactDocuments.map((document) => {
                                    const documentDate = document?.dueDate ? new Date(document?.dueDate) : new Date();

                                    return (
                                        <section className="tw-w-[99%] tw-h-[50px] tw-rounded-lg tw-border-solid tw-border tw-border-gray-300 tw-flex tw-items-center">
                                            <div className={`tw-w-[3px] tw-h-full tw-rounded-l-lg ${document?.meta?.isReceived ? 'tw-bg-red-500' : 'tw-bg-green-600'}`} />
                                            <div className="tw-w-[13.2%] tw-h-full tw-flex tw-items-center tw-justify-center">
                                                {
                                                    document?.meta?.documentId ?
                                                        <span className="tw-font-light tw-text-sm tw-text-gray-700">
                                                            {document?.meta?.documentId}
                                                        </span>
                                                        :
                                                        <span className="tw-font-light tw-text-sm tw-text-gray-400">
                                                            Sin folio
                                                        </span>
                                                }
                                            </div>

                                            <div className="tw-w-[37.7%] tw-h-full tw-flex tw-flex-col tw-p-2">
                                                <span className="tw-font-medium tw-text-sm tw-text-gray-700">
                                                    {
                                                        document?.meta?.typeLabel || document?.meta?.summary || ''
                                                    }
                                                </span>
                                                <span className="tw-font-light tw-text-sm tw-text-gray-700">
                                                    {
                                                        document?.meta?.isReceived ?
                                                            'Recibida'
                                                            :
                                                            'Emitida'
                                                    }

                                                </span>
                                            </div>

                                            <div className="tw-w-[20.8%] tw-h-[50px] tw-px-3 tw-flex tw-items-center">
                                                {
                                                    document.meta.isPaid ?
                                                        (<div className="tw-w-[66px] tw-h-[28px] tw-rounded-md tw-bg-green-50 tw-flex tw-items-center tw-justify-center">
                                                            <span className="tw-font-medium tw-text-sm tw-text-green-600">
                                                                Pagado
                                                            </span>
                                                        </div>)
                                                        :
                                                        documentDate < today ?
                                                            (
                                                                <div className="tw-w-[82px] tw-h-[28px] tw-rounded-md tw-bg-red-50 tw-flex tw-items-center tw-justify-center">
                                                                    <span className="tw-font-medium tw-text-sm tw-text-red-600">
                                                                        Atrasado
                                                                    </span>
                                                                </div>
                                                            )
                                                            :
                                                            (
                                                                <div className="tw-w-[82px] tw-h-[28px] tw-rounded-md tw-bg-yellow-50 tw-flex tw-items-center tw-justify-center">
                                                                    <span className="tw-font-medium tw-text-sm tw-text-yellow-600">
                                                                        Pendiente
                                                                    </span>
                                                                </div>
                                                            )
                                                }
                                            </div>

                                            <div className="tw-w-[20.8%] tw-h-[50px] tw-px-3 tw-flex tw-justify-end tw-items-center">
                                                <span>{formatMoneyWithCurrency(document?.amount)}</span>
                                            </div>

                                            <div className="tw-w-[6.9%] tw-h-[42px] tw-flex tw-items-center tw-justify-center">
                                                <Dropdown
                                                    direction="left"
                                                    icon={
                                                        <FeatherIcon
                                                            icon="more-vertical"
                                                        />
                                                    }
                                                >
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item text="Ver detalle"
                                                            onClick={() => setModalData(document?._id)}
                                                        />
                                                    </Dropdown.Menu>

                                                </Dropdown>
                                            </div>
                                        </section>
                                    )
                                })}
                            </div>

                            <div className="pagination__container tw-flex tw-justify-between tw-items-center tw-gap-3">
                                <div className="tw-flex tw-items-center tw-gap-3">
                                    {
                                        fetchingDocumentsByContact &&
                                        <>
                                            <LoadingSpinner
                                                height="25px"
                                                afterHeight="25px"
                                                afterWidth="25px"
                                            />
                                        </>
                                    }
                                    <span className="tw-text-sm tw-text-gray-500">
                                        Mostrando {startResult} - {endResult} de {totalDocuments} resultados
                                    </span>
                                </div>

                                <div className="tw-flex tw-items-center tw-gap-3">
                                    <Menu compact className="small__dropdown">
                                        <Dropdown
                                            placeholder="Ver"
                                            value={offset}
                                            onChange={onOffsetChange}
                                            options={options}
                                            fluid
                                            selection
                                            style={{ zIndex: 2000 }}
                                        />
                                    </Menu>
                                    <Pagination
                                        boundaryRange={0}
                                        ellipsisItem={null}
                                        firstItem={null}
                                        lastItem={null}
                                        siblingRange={1}
                                        totalPages={totalPages || 1}
                                        onPageChange={onPageChange}
                                        className="small__pagination"
                                        activePage={currentPage}
                                    />
                                </div>
                            </div>
                        </div>
                        :
                        <>
                            <section className="tw-w-full tw-h-[609px] tw-bg-gray-50 tw-flex tw-items-center tw-flex-col tw-justify-center tw-gap-2">
                                <div className="tw-w-[40px] tw-h-[40px] tw-bg-gray-100 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                    <FeatherIcon
                                        icon="file"
                                        size={23}
                                        className="tw-text-gray-500"
                                        strokeWidth={2}
                                    />
                                </div>

                                <span className="tw-text-lg tw-font-semibold tw-text-gray-500">
                                    ¡Nada por ahora!
                                </span>

                                <span className="tw-text-lg tw-font-normal tw-text-gray-500">
                                    No hay documentos asociados a este contacto
                                </span>
                            </section>
                        </>
                }
            </div>
            {
                showDetailModal &&
                <ModalDocumentDetail
                    isVisible={showDetailModal}
                    setIsVisible={setShowDetailModal}
                    data={modalData}
                />
            }
        </>
    )
}